/* =========================================================================
   SAMSARA — ANNOUNCEMENT-BAR.JS (Cat 3.2 rewrite)
   Pattern simplu decuplat: announcement în flow normal, scrolls away natural
   cu page-ul. Header fixed top:0 mereu (decuplat). Acest JS handles DOAR:
     - Dismiss button X (collapse + persist localStorage)
     - Mobile ticker rotation (rotație mesaje cu fade)
   Hide-on-scroll ELIMINAT — scroll natural handle-ază asta.
   Respectă prefers-reduced-motion.
   ========================================================================= */

(function () {
  'use strict';

  const DISMISS_KEY = 'samsara_announcement_dismissed_v5';
  const FADE_DURATION = 400;

  /* Cleanup automat — versiuni anterioare ale dismiss key (v1-v4). v5 introduce
     TTL 24h (stored timestamp în loc de boolean 'true'). */
  try {
    window.localStorage.removeItem('samsara_announcement_dismissed_v1');
    window.localStorage.removeItem('samsara_announcement_dismissed_v2');
    window.localStorage.removeItem('samsara_announcement_dismissed_v3');
    window.localStorage.removeItem('samsara_announcement_dismissed_v4');
  } catch (e) {
    // localStorage blocked — gracefully ignore
  }

  const bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const settings = {
    dismissible: bar.dataset.dismissible === 'true',
    rotationSpeed: (parseInt(bar.dataset.rotationSpeed, 10) || 4) * 1000,
  };

  /* -----------------------------------------------------------------
     DISMISS — X button + persist localStorage
     Adaugă body.announcement-hidden → CSS face collapse smooth max-height + opacity.
     ----------------------------------------------------------------- */
  function initDismiss() {
    if (!settings.dismissible) return;

    // 24h expiry — bara reapare la următoarea vizită dacă > 24h de la dismiss.
    const DISMISS_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

    let wasDismissed = false;
    try {
      const stored = window.localStorage.getItem(DISMISS_KEY);
      if (stored) {
        const dismissedAt = parseInt(stored, 10);
        if (!isNaN(dismissedAt) && (Date.now() - dismissedAt) < DISMISS_TTL_MS) {
          wasDismissed = true;
        } else {
          // Expired — clear stored timestamp
          window.localStorage.removeItem(DISMISS_KEY);
        }
      }
    } catch (e) {
      // localStorage blocked
    }

    if (wasDismissed) {
      document.body.classList.add('announcement-hidden');
      bar.setAttribute('aria-hidden', 'true');
      return;
    }

    const btn = bar.querySelector('[data-announcement-dismiss]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      document.body.classList.add('announcement-hidden');
      bar.setAttribute('aria-hidden', 'true');
      try {
        // Store timestamp (millisecond epoch) — used pentru TTL check pe page load.
        window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
      } catch (e) {
        // localStorage blocked — dismiss rămâne doar pentru această sesiune
      }
    });
  }

  /* -----------------------------------------------------------------
     MOBILE TICKER — rotație mesaje cu fade
     ----------------------------------------------------------------- */
  function initTicker() {
    if (reducedMotion) return;

    const ticker = bar.querySelector('[data-announcement-ticker]');
    if (!ticker) return;

    let messages = [];
    try {
      messages = JSON.parse(ticker.dataset.messages || '[]');
    } catch (e) {
      return;
    }

    messages = messages.filter(function (m) {
      return m && typeof m === 'string' && m.trim().length > 0;
    });

    if (messages.length < 2) return;

    const msgEl = ticker.querySelector('[data-announcement-message]');
    if (!msgEl) return;

    let idx = 0;

    setInterval(function () {
      msgEl.style.opacity = '0';
      setTimeout(function () {
        idx = (idx + 1) % messages.length;
        msgEl.textContent = messages[idx];
        msgEl.style.opacity = '1';
      }, FADE_DURATION);
    }, settings.rotationSpeed);
  }

  function boot() {
    initDismiss();
    initTicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
